export const PRINTERS_FEATURE_KEY = 'printers';
